/**
 * Tabblad Sessies: een les klaarzetten voor een klas (stelling, klas,
 * datum), en een les aan- of uitzetten. Een actieve les is wat een
 * leerling ziet als hij inlogt.
 */
import React, { useState } from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';
import { useLessen } from '../hooks/useLessen';

const LEGE_SESSIE = { statement_id: '', class_id: '', datum_vanaf: '' };

export function Sessies({ api }) {
  const lessen = useLessen(api);
  const [nieuw, setNieuw] = useState(null);

  const maak = async (e) => {
    e.preventDefault();
    try {
      const data = await api.maakSessie(nieuw);
      if (data.success) { setNieuw(null); lessen.haalSessies(); }
    } catch (err) { console.error('Fout:', err); }
  };

  const wissel = async (sessie) => {
    try {
      const data = await api.zetSessie(sessie.id, !sessie.is_actief);
      if (data.success) lessen.haalSessies();
    } catch (err) { console.error('Fout:', err); }
  };

  const verwijder = async (id) => {
    if (!window.confirm('Weet je zeker?')) return;
    try {
      const data = await api.verwijderSessie(id);
      if (data.success) lessen.haalSessies();
    } catch (err) { console.error('Fout:', err); }
  };

  return (
    <div style={styles.card}>
      <div style={styles.panelHeader}>
        <h2>Sessies</h2>
        <button onClick={() => setNieuw(LEGE_SESSIE)} style={styles.addBtn}>+ Nieuwe Sessie</button>
      </div>
      {nieuw && (
        <form onSubmit={maak} style={styles.form}>
          <select value={nieuw.statement_id} onChange={(e) => setNieuw({ ...nieuw, statement_id: e.target.value })} style={styles.input} required>
            <option value="">-- Kies een stelling --</option>
            {lessen.stellingen.map(s => <option key={s.id} value={s.id}>{s.icon} {s.titel}</option>)}
          </select>
          <select value={nieuw.class_id} onChange={(e) => setNieuw({ ...nieuw, class_id: e.target.value })} style={styles.input} required>
            <option value="">-- Kies een klas --</option>
            {lessen.klassen.map(k => <option key={k.id} value={k.id}>{k.naam}</option>)}
          </select>
          <input type="date" value={nieuw.datum_vanaf} onChange={(e) => setNieuw({ ...nieuw, datum_vanaf: e.target.value })} style={styles.input} required />
          <div style={styles.formButtons}>
            <button type="submit" style={styles.saveBtn}>Aanmaken</button>
            <button type="button" onClick={() => setNieuw(null)} style={styles.cancelBtn}>Annuleren</button>
          </div>
        </form>
      )}
      {lessen.laden ? <p>Laden...</p> : lessen.sessies.length === 0 ? <p style={styles.empty}>Nog geen sessies.</p> : (
        <div style={styles.sessiesList}>
          {lessen.sessies.map((sessie) => {
            const stelling = lessen.stellingVan(sessie);
            const klas = lessen.klasVan(sessie);
            return (
              <div key={sessie.id} style={styles.sessieCard}>
                <div style={styles.sessieInfo}>
                  <div style={styles.sessieTitle}>{stelling?.icon || '📜'} {stelling?.titel || 'Onbekend'}</div>
                  <div style={styles.sessieMeta}>{klas?.naam || 'Onbekend'} (leerjaar {klas?.leerjaar || 6}) • {sessie.datum_vanaf}</div>
                </div>
                <div style={styles.sessieActions}>
                  <button onClick={() => wissel(sessie)} style={sessie.is_actief ? styles.activeBtn : styles.inactiveBtn}>
                    {sessie.is_actief ? 'Actief' : 'Inactief'}
                  </button>
                  <button onClick={() => verwijder(sessie.id)} style={styles.deleteBtn}>🗑️</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const styles = {
  ...basis,
  sessiesList: { display: 'flex', flexDirection: 'column', gap: '12px' },
  sessieCard: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', background: kleur.vlak, borderRadius: '8px' },
  sessieInfo: { flex: 1 },
  sessieTitle: { fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' },
  sessieActions: { display: 'flex', alignItems: 'center', gap: '8px' },
  activeBtn: { padding: '8px 16px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', width: '80px', textAlign: 'center' },
  inactiveBtn: { padding: '8px 16px', background: 'white', color: 'black', border: '1px solid black', borderRadius: '6px', cursor: 'pointer', width: '80px', textAlign: 'center' },
};
